import EditCapacityForm from './edit-capacity-container';

export default EditCapacityForm;
